import styled from "styled-components";
import { devices } from "../../globalStyle";
import { Link } from "react-router-dom";

export const StyledLink = styled(Link)`
  user-select: none;
`

export const HeaderContainer = styled.header`
  display: flex;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  padding: 1.3rem 3rem;
  gap: 7rem;
  img{
    height: 1.7rem;
  }
`

export const LogoutWrapper = styled.div`
position: relative;
  display: inline-block;

  &:hover::after {
    content: 'Logout';
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
    background: #1f1f1f;
    color:rgb(204, 204, 204);
    padding: 5px 8px;
    border-radius: 1px;
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
  }

  &:hover::after {
    opacity: 1;
  }
`;

export const SearchDiv = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  background-color: #f4f4f4;
  padding: .2rem .8rem;
  height: 3rem;
  flex: 1;
  max-width: 100rem;
  border-radius: 4rem;

  @media ${devices.largeDesktop} {

  }
`

export const SearchInput = styled.input`
  display: flex;
  border: 0;
  background-color: #f4f4f4;
  height: 100%;
  width: 100%;

  :focus {
    outline: none;
  }

  @media ${devices.largeDesktop} {
  }
`

export const SearchImg = styled.img`
  width: 1.3rem;
  cursor: pointer;

  @media ${devices.largeDesktop} {

  }
`

export const InfoDiv = styled.div`
  display: flex;
  align-items: center;
  user-select: none;
  gap: .7rem;
  img{
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
  }
`